import { render, staticRenderFns } from "./DriverHistory.vue?vue&type=template&id=48175b38&"
import script from "./DriverHistory.vue?vue&type=script&lang=js&"
export * from "./DriverHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports